"use client";

import { Clock, TriangleAlert as AlertTriangle, FastForward as ClockForward, Info } from 'lucide-react';
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Technicalfleetdashboard() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const materials = [{
    name: "Hora de recogida",
    description: "Seguimiento preciso del momento exacto en que el transporte llega al punto de encuentro.",
    tensile: "Estado",
    temp: "En tiempo real",
    Icon: Clock
  }, {
    name: "Retrasos",
    description: "Detección automática y notificación inmediata de cualquier desviación en el horario previsto.",
    tensile: "Alerta",
    temp: "Crítica",
    Icon: AlertTriangle
  }, {
    name: "Hora prevista de regreso",
    description: "Cálculo dinámico de la llegada al resort basado en el tráfico y el progreso de la excursión.",
    tensile: "Precisión",
    temp: "+/- 2 min",
    Icon: ClockForward
  }, {
    name: "Información actualizada para huéspedes",
    description: "Canal directo de comunicación para mantener a los clientes informados sobre su itinerario.",
    tensile: "Soporte",
    temp: "24/7",
    Icon: Info
  }];
  return <section data-section-id="2254" id="technicalfleetdashboard" className="bg-background text-foreground py-20 md:py-28 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
        <div ref={headerRef} className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-16 md:mb-20 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="md:col-span-6">
            <p className="font-mono text-xs md:text-sm tracking-[0.2em] uppercase mb-6" style={{
            color: "var(--chart-1)"
          }}>
              Excursion Control
            </p>
            <h2 className="font-serif font-default text-4xl md:text-5xl lg:text-[56px] leading-[1.05] tracking-tight text-foreground">
              Control total sobre su movilidad.
            </h2>
          </div>
          <div className="md:col-span-6 md:pt-4">
            <p className="text-base md:text-lg leading-relaxed text-muted-foreground max-w-xl">
              Seguimiento inteligente de excursiones y autobuses.
            </p>
          </div>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 transition-all duration-700 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {materials.map((material, i) => {
          const Icon = material.Icon;
          return <div data-index={i} key={material.name} className="group relative rounded-lg border border-border bg-card p-7 md:p-8 transition-all duration-300 ease-out hover:-translate-y-1 shadow-md hover:shadow-lg" style={{
            backgroundColor: "var(--card)"
          }}>
                <div className="mb-7 inline-flex h-[60px] w-[60px] items-center justify-center rounded-lg transition-colors duration-300" style={{
              backgroundColor: "var(--muted)"
            }}>
                  <Icon className="h-6 w-6 transition-colors duration-300 group-hover:text-background" strokeWidth={1.25} style={{
                color: "var(--chart-1)"
              }} />
                  <span className="absolute pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300 h-[60px] w-[60px] rounded-lg -z-0" aria-hidden="true" />
                </div>

                <style>{`
                  .group:hover [data-badge-fill="${i}"] {
                    background-color: var(--chart-1);
                  }
                `}</style>

                <h3 className="font-serif font-default text-[28px] leading-tight text-card-foreground mb-3">
                  {material.name}
                </h3>

                <p className="text-sm leading-relaxed text-muted-foreground mb-8">
                  {material.description}
                </p>

                <div className="pt-5 border-t border-border">
                  <p className="font-mono text-xs tracking-wider uppercase" style={{
                color: "var(--muted-foreground)"
              }}>
                    <span style={{
                  color: "var(--chart-1)"
                }}>{material.tensile}:</span>{" "}
                    <span className="text-foreground">{material.temp}</span>
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>

      <style>{`
        #technicalfleetdashboard .group:hover .material-badge-icon {
          color: var(--primary-foreground);
        }
      `}</style>
    </section>;
}